/**
 * Collection Media Break
 *
 * Liquid inserts every banner after the product that matches its configured
 * row. CSS Grid should follow that DOM order on both breakpoints.
 */

(function() {
  'use strict';

  let resizeTimer;

  function fixMediaBreakPositions() {
    const mediaBreaks = document.querySelectorAll('.product-card-list .collection-media-break');
    if (!mediaBreaks.length) return;

    mediaBreaks.forEach(mediaBreak => {
      mediaBreak.style.removeProperty('grid-row');
      mediaBreak.style.gridColumn = '1 / -1';
      const image = mediaBreak.querySelector('img.collection-media-break--media');
      if (image?.complete && image.naturalWidth) setMediaWidth(image);
    });
  }

  function setMediaWidth(image) {
    image.closest('.collection-media-break')?.classList.toggle(
      'collection-media-break--wide', image.naturalWidth > image.naturalHeight
    );
  }

  document.addEventListener('load', (event) => {
    if (event.target.matches?.('img.collection-media-break--media')) {
      setMediaWidth(event.target);
    }
  }, true);
  
  function init() {
    fixMediaBreakPositions();
  }
  
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Ekran tipi değiştiğinde doğru konumlandırma yöntemine geç.
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      fixMediaBreakPositions();
    }, 250);
  }, { passive: true });

  // Run on infinite scroll
  document.addEventListener('infiniteScrollLoaded', () => {
    setTimeout(() => {
      fixMediaBreakPositions();
    }, 100);
  });
})();
